import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";

class Footer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <footer className="footer">
        <div className="container">
          <div className="row text-muted">
            <div className="col-6 text-start">
              <ul className="list-inline">
                <li className="list-inline-item">
                  <Link className="text-muted" to="/support-center">
                    Support
                  </Link>
                </li>
                <li className="list-inline-item">
                  <Link className="text-muted" to="/help-center">
                    Help Center
                  </Link>
                </li>
                <li className="list-inline-item">
                  <Link className="text-muted" to="/privacy">
                    Privacy Policy
                  </Link>
                </li>
                <li className="list-inline-item">
                  <Link className="text-muted" to="/terms-of-service">
                    Terms of Service
                  </Link>
                </li>
              </ul>
            </div>
            <div className="col-6 text-end">
              <p className="mb-0">
                &copy; {new Date().getFullYear()} -{" "}
                <span className="text-muted">Simply Collaborate, LLC</span>
              </p>
            </div>
          </div>
        </div>
      </footer>
    );
  }
}

export default connect((store) => ({
  app: store.app,
  auth: store.auth,
}))(Footer);
